import { atom } from 'recoil'

export const modalNewSourceState = atom({
  key: 'campaignWizardmodalNewSourceState',
  default: {
    show: false,
    sourceType: 'feed',
    sourceName: '',
    sourceNameIsDirty: '',
    sourceUrl: '',
    sourceUrlIsDirty: '',
    sourceUrlInvalid: false
  }
})

export const modalConfirmEditMessageState = atom({
  key: 'campaignWizardmodalConfirmEditMessageState',
  default: {
    show: false,
    title: '',
    message: '',
    stringCancel: '',
    stringConfirm: '',
    onClickCancel: undefined,
    onClickConfirm: undefined
  }
})

export const modalExitEditMessageState = atom({
  key: 'campaignWizardmodalExitEditMessageState',
  default: {
    show: false,
    title: '',
    message: '',
    stringCancel: '',
    stringConfirm: '',
    onClickCancel: undefined,
    onClickConfirm: undefined
  }
})

export const modalEmptySourceState = atom({
  key: 'campaignWizard__modalEmptySourceState',
  default: {
    show: false
  }
})

export const modalLimitDataContentState = atom({
  key: 'campaignWizard__modalLimitDataContentState',
  default: {
    show: false,
    replaceValue: 0
  }
})

export const modalConfirmIgnoreChangesState = atom({
  key: 'campaignWizard__modalConfirmIgnoreChangesState',
  default: {
    show: false,
    redirectRoute: ''
  }
})

export const modalConcurrentAccess = atom({
  key: 'campaignWizard__ModalConcurrentAccess',
  default: {
    show: false
  }
})

export const modalThirdPartyState = atom({
  key: 'campaignWizard__modalThirdPartyState',
  default: {
    show: false
  }
})

export const modalFilterDetailsState = atom({
  key: 'campaignWizard__modalFilterDetailsState',
  default: {
    show: false,
    type: null,
    name: '',
    description: '',
    id: 0
  }
})
